import {HTMLAttributes, MouseEventHandler} from 'react';
import {twMerge} from '../../../common/twMerge';
import {Button} from '../../atoms/Button/Button';
import {ButtonColorScheme, ButtonSize} from '../../atoms/Button/Button.enum';

interface BelowTabButtonProps extends HTMLAttributes<HTMLButtonElement> {
  isRound?: boolean;
  onClick?: MouseEventHandler;
}

export function BelowTabButton({
  children,
  isRound,
  className,
  onClick,
  ...props
}: BelowTabButtonProps) {
  return (
    <Button
      size={ButtonSize.Small}
      colorScheme={ButtonColorScheme['4st']}
      isRound={isRound}
      onClick={onClick}
      className={twMerge('shrink-0', className)}
      {...props}
    >
      {children}
    </Button>
  );
}

export const BelowTabButtonType = (<BelowTabButton />).type;
